import { ReactElement } from "react";
import dynamic from "next/dynamic";

const SignIn = dynamic(() => import('../src/SignIn/SignIn'), { ssr: false });

export default function signIn(): ReactElement {
  return <SignIn />
}
